import { ChakraProvider } from '@chakra-ui/react';

import OnlineStatus from '@/components/0-reusable-components/connectivity-indicator';
import CookieConsent from '@/components/0-reusable-components/cookie-consent';
import Authenticated from '@/components/all-providers/authenticated';
import I18n from '@/components/all-providers/i18n';
import ScriptLoader from '@/components/all-providers/script-loader';
import Layout from '@/layouts/layout';
import theme from '@/styles/ui.theme';

type Props = {
  children: React.ReactElement;
};

const AllProviders = ({ children }: Props): React.ReactElement => (
  <ChakraProvider theme={theme}>
    <ScriptLoader>
      <Authenticated>
        <CookieConsent>
          <I18n>
            <Layout>
              <OnlineStatus>{children}</OnlineStatus>
            </Layout>
          </I18n>
        </CookieConsent>
      </Authenticated>
    </ScriptLoader>
  </ChakraProvider>
);

export default AllProviders;
